module.exports = __webpack_public_path__ + "static/img/tab1zh-Gg5Hh6Ii.e6f6593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/tab1zh-Gg5Hh6Ii.png
// module id = rCVo
// module chunks = 16